export class CreateCustomerObjectDeviceDto {
    deviceTypeId: number;
    deviceModelId: number;
    deviceModelName: string;
    serialNumber: string;
    deviceStatusId: number;
    ownerContragentId: number;
    requestCategoryId: number;
    installationDate: Date;
}